import React from 'react'
import {useHandlePriceDetailsClick} from 'components/Accommodation/Rooms/RoomOffer/useHandlePriceDetailsClick'
import {RoomOfferPrice} from 'components/Accommodation/Rooms/RoomOfferPrice/RoomOfferPrice'

import {Offer} from '@vio/core/src/offer/types/offer'
import {Room} from '@vio/core/src/room/types/room'

interface PrimaryRegularOfferPriceProps {
  hotelId: string
  room: Room
  offer: Offer
  component: string
  isVioTagVisible?: boolean
  isCompact?: boolean
  hidePriceDetails?: boolean
}
export const PrimaryRegularOfferPrice = ({
  hotelId,
  room,
  offer,
  component,
  isVioTagVisible = false,
  isCompact = false,
  hidePriceDetails = false
}: PrimaryRegularOfferPriceProps) => {
  const handlePriceDetailsClick = useHandlePriceDetailsClick({
    hotelId,
    room,
    offer,
    component
  })
  return (
    <RoomOfferPrice
      hotelId={hotelId}
      offer={offer}
      onClickPriceDetails={handlePriceDetailsClick}
      isVioTagVisible={isVioTagVisible}
      isCompact={isCompact}
      hidePriceDetails={hidePriceDetails}
    />
  )
}
